module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pso"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "video_cont"
  }, [_c('video', {
    attrs: {
      "src": _vm.urls.psoVideoLink,
      "controls": "controls"
    },
    on: {
      "play": _vm.playVideoHandler
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "next_cont"
  }, [_c('a', {
    staticClass: "button",
    class: {
      cancel: !_vm.videoIsPlay
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.nextHandler
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "guide"
  }, [_vm._v("\n    Congratulations on passing your final interview with our Recruitment Team! "), _c('br'), _vm._v("\n    To learn more about our HAWO Group Class training program, please watch the videos below:\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pso_tip"
  }, [_c('p', [_vm._v("We hope you were able to get a better understanding of the basics of Group Class, the training path, and the expectations we have for this training.")]), _vm._v(" "), _c('p', [_vm._v("\n      Please make sure to check your email or Skype for the next step/s in the process. Your recruiter will be reaching out to you via those channels."), _c('br'), _vm._v("\n      You may also add the HAWO Recruitment Skype: live:.cid.9d7dbebba05d49b9 for faster coordination.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=uP-SCPvDsngQu9OslgM&guid=ON&script=0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2edbcd0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pso/pso.vue
// module id = 828
// module chunks = 1